/**
 * toProvisionalCode (design D16, task 6.2) — a display-only placeholder shown
 * on the valet's screen between capture and sync. `P-` + the first 4 hex
 * chars of the item's `id` (= clientRequestId, a UUID), uppercased. Cannot
 * collide with an official (numeric) ticket number, and is fully derived
 * from data the device already has offline — no server round trip needed to
 * show SOMETHING to the valet immediately.
 */
export function toProvisionalCode(clientRequestId: string): string {
  const hex = clientRequestId.replace(/-/g, '').slice(0, 4).toUpperCase();
  return `P-${hex}`;
}
